import React from 'react'

const Contact = () => {
  return (
    <div class='contact-div1'>
        <div class='contact-div'>
            {/* <h1 class='about-h'>Contact Us</h1> */}
        </div>
        <h1 class='contact-h1 mt-5 d-flex justify-content-center'>RJ Engineering</h1>
        <h2 class='contact-h12 mt-3 text-white d-flex justify-content-center'>Contact Us</h2>
        <div class='container'>
            <div class='row mt-5'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <h2 class='contact-h'>Get in touch with us for reliable engineering solutions.</h2>
                    
                    <p class='contact-p'>R J Engineering is a Mechanical,Electrical,Plumbing and Fire Protection Service contracting company in Bengaluru,specializing in design,build,construct,supply,install,service,upgrade,maintenance of electro-mechanical systems & networks,utilities and equipment.</p>
                    {/* <h4 class='contact-head'>Address :</h4>
                    <p class='contact-para'>First floor,Site no 46,Drishrik plaza,Neralur,<br></br>
                    Attibele Hobli,Anekal Taluk,<br></br>
                    Bangalore 562107</p>
                    <h4 class='contact-head'>Mob :</h4>
                    <p class='contact-para'>+91 9606577402</p>
                    <h4 class='contact-head'>Email :</h4>
                    <p class='contact-para'>info@rjengineering.org</p>
                    <p class='contact-para'>rajeshsebastianrj@gmail.com</p> */}
                    <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3890.775135074839!2d77.728652!3d12.793102999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDQ3JzM1LjIiTiA3N8KwNDMnNDMuMiJF!5e0!3m2!1sen!2sin!4v1773750078540!5m2!1sen!2sin" height="380" title='add' class='map' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center'>
                <form class='contact-form'>
                    <label class='form-label contact-form1'>Name</label>
                    <input type="text" required='true' name='nam' class='form-control contact-form1' placeholder='Enter Your Full Name' size="50" /><br></br>
                    <label class='form-label contact-form1'>Contact Number</label>
                    <input type="text" required='true' name='cont' class='form-control contact-form1' placeholder='Enter Your Contact Number' size="50" /><br></br>
                    <label class='form-label contact-form1'>Email</label> 
                    <input type="text" required='true' name='ema' class='form-control contact-form1' placeholder='Enter Your Email' size="50" /><br></br>
                    <label class='form-label contact-form1'>Project Type</label> 
                    <select class='w-100 contact-form2'>
                        <option value=''>Select</option>
                        <option value=''>Annual Maintenance Works</option>
                        <option value=''>Fire Hydrant  Works</option>
                        <option value=''>Fire Alarm & Security System Works</option>
                        <option value=''>plumbing Works</option>
                        <option value=''>HVAC Works</option>
                        <option value=''>Electrical Works</option>
                    </select><br></br>
                    <label class='form-label contact-form1'>Message</label>
                    <textarea rows='5' required='true' cols='50' name='mess' class='form-control'></textarea>
                    <button type='submit'  class='btn btn-dark mt-3'>Submit</button>
                </form>
            </div>
            </div>
        </div>
        <div class='container'>
            <div class='row mt-4'>
            <h2 class='about-h4'>🔥 Fire Safety Focused</h2>
            <p class='about-para1 ms-2'>📞 Protect what matters most—get in touch with us..</p>
            </div>
        </div>
    </div>
  )
}

export default Contact